import * as algoliasearch from 'algoliasearch/lite';
import * as instantsearch from 'instantsearch.js/dist/instantsearch.production.min';
import daterangepicker from 'daterangepicker/daterangepicker';
import moment from 'moment/src/moment';

$(document).ready(function () {
  if ($('.search-results-page').length == 0) return;

  function fixedEncodeURIComponent(str) {
    return encodeURIComponent(str.toLowerCase()).replace(/%20/g, '+');
  }

  // Reference: https://github.com/simov/slugify
  function slugify(string, options) {
    var charMap = JSON.parse(
      '{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}'
    );
    var locales = JSON.parse(
      '{"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Æ":"AE","Ø":"OE","Å":"AA","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"Større end"}}'
    );

    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected');
    }

    options =
      typeof options === 'string' ? { replacement: options } : options || {};

    var locale = locales[options.locale] || {};

    var replacement =
      options.replacement === undefined ? '-' : options.replacement;

    var trim = options.trim === undefined ? true : options.trim;

    var slug = string
      .normalize()
      .split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        return (
          result +
          (locale[ch] || charMap[ch] || (ch === replacement ? ' ' : ch))
            // remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
        );
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim();
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase();
    }

    return slug;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const indexNameParam = urlParams.get('in');
  const indexName = indexNameParam === 'ClassNote' ? 'ClassNote' : 'Content';

  let titleAttribute = 'name';

  if (indexName === 'ClassNote') {
    titleAttribute = 'title';
  }

  const facetItemTemplate =
    '<label class="{{cssClasses.label}}">\n  <input type="checkbox"\n         class="{{cssClasses.checkbox}}"\n         value="{{value}}"\n         {{#isRefined}}checked{{/isRefined}} />\n  <span class="{{cssClasses.labelText}}">{{label}}</span>\n  <span class="{{cssClasses.count}}">({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})</span>\n</label>';

  function safeDecodeURIComponent(value) {
    try {
      return decodeURIComponent(value);
    } catch (error) {
      return '';
    }
  }

  function sanitizeRefinementValue(value) {
    return safeDecodeURIComponent(value).replace(/[<>]/g, '');
  }

  const search = instantsearch({
    indexName: indexName,
    hitsPerPage: 10,
    maxValuesPerFacet: 1000,
    searchClient: algoliasearch(
      gon.algolia_app_id,
      gon.algolia_search_only_api_key
    ),
    searchParameters: {
      facetingAfterDistinct: true,
    },
    routing: {
      router: instantsearch.routers.history({
        createURL({ qsModule, routeState, location }) {
          const urlParts = location.href.match(/^(.*?)\/search/);
          const baseUrl = `${urlParts ? urlParts[1] : ''}/`;
          const queryParameters = {};

          if (routeState.query)
            queryParameters.query = fixedEncodeURIComponent(routeState.query);

          if (routeState.sortBy) queryParameters.sortBy = routeState.sortBy;

          if (routeState.in)
            queryParameters.in = fixedEncodeURIComponent(routeState.in);

          if (routeState.page !== 1) queryParameters.page = routeState.page;

          if (routeState.authors)
            queryParameters.authors = routeState.authors.map(
              fixedEncodeURIComponent
            );

          if (routeState.categories)
            queryParameters.categories = routeState.categories.map(
              fixedEncodeURIComponent
            );

          if (routeState.sections)
            queryParameters.sections = routeState.sections.map(
              fixedEncodeURIComponent
            );

          if (routeState.issues)
            queryParameters.issues = routeState.issues.map(
              fixedEncodeURIComponent
            );

          if (routeState.titles)
            queryParameters.titles = routeState.titles.map(
              fixedEncodeURIComponent
            );

          if (indexName === 'ClassNote') {
            queryParameters.in = indexName;
          }
          const queryString = qsModule.stringify(queryParameters, {
            addQueryPrefix: true,
            encode: false,
            arrayFormat: 'repeat',
          });

          return `${baseUrl}search${queryString}`;
        },

        parseURL({ qsModule, location }) {
          const {
            query = '',
            in: indexName,
            sortBy,
            page,
            authors = [],
            sections = [],
            categories = [],
            issues = [],
            titles = [],
          } = qsModule.parse(location.search.slice(1));

          // `qs` does not return an array when there's a single value.
          const allAuthors = Array.isArray(authors)
            ? authors
            : [authors].filter(Boolean);
          const allCategories = Array.isArray(categories)
            ? categories
            : [categories].filter(Boolean);
          const allSections = Array.isArray(sections)
            ? sections
            : [sections].filter(Boolean);
          const allIssues = Array.isArray(issues)
            ? issues
            : [issues].filter(Boolean);
          const allGraduationDecades = Array.isArray(titles)
            ? titles
            : [titles].filter(Boolean);

          return {
            query: safeDecodeURIComponent(query),
            in: indexName,
            sortBy,
            page,
            authors: allAuthors.map(sanitizeRefinementValue).filter(Boolean),
            categories: allCategories
              .map(sanitizeRefinementValue)
              .filter(Boolean),
            sections: allSections.map(sanitizeRefinementValue).filter(Boolean),
            issues: allIssues.map(sanitizeRefinementValue).filter(Boolean),
            titles: allGraduationDecades
              .map(sanitizeRefinementValue)
              .filter(Boolean),
          };
        },
      }),

      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState || {};

          return {
            query: indexUiState.query,
            in: indexUiState.in,
            sortBy: indexUiState.sortBy,
            page: indexUiState.page,
            authors:
              indexUiState.refinementList && indexUiState.refinementList.author,
            categories:
              indexUiState.refinementList &&
              indexUiState.refinementList.categorie,
            sections:
              indexUiState.refinementList &&
              indexUiState.refinementList.section,
            issues:
              indexUiState.refinementList && indexUiState.refinementList.issue,
            titles:
              indexUiState.refinementList && indexUiState.refinementList.title,
          };
        },

        routeToState(routeState) {
          return {
            query: routeState.query,
            in: routeState.in,
            sortBy: routeState.sortBy,
            page: routeState.page,
            refinementList: {
              author: routeState.authors,
              categories: routeState.categories,
              section: routeState.sections,
              issue: routeState.issues,
              title: routeState.titles,
            },
          };
        },
      },
    },
  });

  search.addWidget(
    instantsearch.widgets.searchBox({
      container: '#search-query',
    })
  );

  if (indexName === 'Content') {
    search.addWidget(
      instantsearch.widgets.refinementList({
        container: '#authors',
        attribute: 'author',
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        sortBy: ['count:desc', 'name:asc'],
        templates: {
          item: facetItemTemplate,
          showMoreText: `
            {{#isShowingMore}}
              Show fewer authors
            {{/isShowingMore}}
            {{^isShowingMore}}
              Show more authors
            {{/isShowingMore}}
          `,
        },
      })
    );

    search.addWidget(
      instantsearch.widgets.refinementList({
        container: '#categories',
        attribute: 'categories',
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        sortBy: ['name:asc'],
        templates: {
          item: facetItemTemplate,
          showMoreText: `
            {{#isShowingMore}}
              Show fewer categories
            {{/isShowingMore}}
            {{^isShowingMore}}
              Show more categories
            {{/isShowingMore}}
          `,
        },
      })
    );

    search.addWidget(
      instantsearch.widgets.refinementList({
        container: '#sections',
        attribute: 'section',
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        sortBy: ['count:desc'],
        templates: {
          item: facetItemTemplate,
          showMoreText: `
            {{#isShowingMore}}
              Show fewer sections
            {{/isShowingMore}}
            {{^isShowingMore}}
              Show more sections
            {{/isShowingMore}}
          `,
        },
      })
    );
  } else {
    search.addWidget(
      instantsearch.widgets.refinementList({
        container: '#issues',
        attribute: 'issue',
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        templates: {
          showMoreText: `
            {{#isShowingMore}}
              Show fewer issues
            {{/isShowingMore}}
            {{^isShowingMore}}
              Show more issues
            {{/isShowingMore}}
          `,
        },
      })
    );

    search.addWidget(
      instantsearch.widgets.refinementList({
        container: '#graduation-decades',
        attribute: 'title',
        limit: 10,
        showMore: true,
        showMoreLimit: 1000,
        searchable: false,
        templates: {
          showMoreText: `
            {{#isShowingMore}}
              Show fewer graduation decades
            {{/isShowingMore}}
            {{^isShowingMore}}
              Show more graduation decades
            {{/isShowingMore}}
          `,
        },
      })
    );
  }

  search.addWidget(
    instantsearch.widgets.sortBy({
      container: '#sort-by',
      items: [
        { label: 'MOST RELEVANT', value: indexName },
        { label: 'Newest', value: indexName + '_Date_Desc' },
      ],
    })
  );

  function renderNoResultsWidget(query) {
    const container = document.querySelector('#hits');
    const url = document.location.origin + '/random-latest';

    $.get(url, (contents) => {
      container.innerHTML = ``;
      $('#hits').prepend(`
        <div class="bg-white text-center p-[25px]">
          <h2 class="no-result__title feature-article-desc font-serif-pro
          text-xl heading-[27px] tracking-[0.3px] text-s-light-black ">No results found</h2>
        </div>
      `);
    });
  }

  function updateFiltersForNoResults() {}

  search.addWidget(
    instantsearch.widgets.stats({
      container: '#stats',
      templates: {
        text: (data) => {
          if (data.hasNoResults) {
            updateFiltersForNoResults();
            renderNoResultsWidget(data.query);
            return;
          }

          if (data.hasOneResult) {
            return '<b>1</b> result';
          }

          if (data.hasManyResults) {
            const startResult = data.page * data.hitsPerPage + 1;
            const maxItemsOnPage = (data.page + 1) * data.hitsPerPage;
            const endResult =
              data.nbHits < maxItemsOnPage ? data.nbHits : maxItemsOnPage;

            return `<b>${startResult}</b> - <b>${endResult}</b> of <b>${data.nbHits}</b> results found`;
          }
        },
      },
    })
  );

  function formatDate(date) {
    return moment(date).format('LL');
  }

  const renderHits = (renderOptions, isFirstRender) => {
    if (isFirstRender) return;
    const { hits, results } = renderOptions;

    const container = document.querySelector('#hits');

    container.innerHTML = `
      ${hits
        .map(
          (item) =>
            `
          <div class="">
  <div class="cursor-pointer shadow-md flex-wrapper bg-white mb-[25px] flex flex-col sm:flex-row md:h-auto content-card-hover" onclick="window.location.href='/${
    typeof item.id == 'undefined'
      ? item.slug
      : indexName == 'ClassNote'
      ? `class_notes/${item.issue_slug}/${item.graduation_decade}?search=${results.query}`
      : `contents/${item.slug}`
  }';">
    <div class="block sm:inline-block md:w-full p-[25px] flex-1">

      <h3 class="feature-article-name font-serif-pro font-bold text-3xl leading-[28px] text-s-light-black">
        <a href="/${
          typeof item.id == 'undefined'
            ? item.slug
            : indexName == 'ClassNote'
            ? `class_notes/${item.issue_slug}/${item.graduation_decade}?search=${results.query}`
            : `contents/${item.slug}`
        }" onclick="event.stopPropagation();">
          ${instantsearch.highlight({
            attribute: titleAttribute,
            hit: item,
          })}
        </a>
      </h3>

      <p class="my-[10px] overflow-hidden break-words font-serif-pro text-xl text-s-light-black min-h-[110px]">
        ${instantsearch.snippet({ attribute: 'body', hit: item })}
      </p>

      ${
        item.author
          ? `
        <p class="small-search-query font-serif-pro text-xl text-s-light-black
        leading-[23px] tracking-[0.3px] text-s-light-black ">by
          <span class="font-semibold">
            ${instantsearch.highlight({
              attribute: 'author',
              hit: item,
            })}
          </span>
        </p>
        `
          : ''
      }

      <div class="mt-[15px]">
        ${
          item.issue
            ? `
          <a href="/${indexName == 'ClassNote' ? 'class_notes' : 'issues'}/${
                item.issue_slug
              }" class="search-article-section
            font-sans-pro text-m leading-[16px] tracking-[0.4px] text-s-light-black ${
              indexName == 'ClassNote' ? '' : 'border-r'
            } pr-[10px] border-s-ligth-grey/50 hover:underline" onclick="event.stopPropagation();">
            ${item.issue}
          </a>
        `
            : `<span class="search-article-section
            font-sans-pro text-m leading-[16px] tracking-[0.4px] text-s-light-black ${
              indexName == 'ClassNote' ? '' : 'border-r'
            } pr-[10px] border-s-ligth-grey/50">${item.date}</span>`
        }

        ${
          item.section
            ? `
        <a href="/sections/${
          item.section_slug || slugify(item.section, { lower: true })
        }" class="small-search-query
        search-article-section ml-[10px] font-sans-pro leading-[16px] tracking-[0.4px] text-s-dark-red hover:underline text-s-digital-red hover:underline hover:text-s-cardinal-red" onclick="event.stopPropagation();">
          ${item.section}
        </a>
        `
            : ''
        }
      </div>

    </div>

    ${
      item.cover_url
        ? `
        <span class="hidden lg:inline-block">
          <div class="block md:inline-block w-full sm:w-[355px] h-full bg-no-repeat bg-[center] bg-cover s-card-shadow" style="background-image: url('${item.cover_url}');">
          </div>
        </span>
      `
        : ''
    }
  </div>
</div>

          `
        )
        .join('')}
    `;
  };

  const customHits = instantsearch.connectors.connectHits(renderHits);

  search.addWidgets([customHits({})]);

  const renderPagination = (renderOptions, isFirstRender) => {
    const {
      pages,
      currentRefinement,
      isFirstPage,
      isLastPage,
      refine,
      nbPages,
      createURL,
    } = renderOptions;

    const container = document.querySelector('#pagination');
    if (nbPages == 0 || nbPages == 1) {
      container.innerHTML = '';
      return;
    }
    container.innerHTML = `
      <nav class="pagy-nav pagination" role="navigation" aria-label="pager">
        ${
          !isFirstPage
            ? `
              <span class="next-page">
                <a
                  href="${createURL(currentRefinement - 1)}"
                  data-value="${currentRefinement - 1}"
                >
                  Prev
                </a>
              </span>
             `
            : ''
        }
        ${pages
          .map(
            (page) => `
            <span class="search-page ${
              currentRefinement === page ? 'active' : ''
            }">
              ${
                currentRefinement != page
                  ? `
                <a
                  href="${createURL(page)}"
                  data-value="${page}"
                >
                ${page + 1}
                </a>
              `
                  : page + 1
              }
            </span>
          `
          )
          .join('')}
          ${
            !isLastPage
              ? `<span class="next-page">
              <a
                href="${createURL(currentRefinement + 1)}"
                data-value="${currentRefinement + 1}"
              >
              Next
              </a>
            </span>`
              : ''
          }
      </nav>
    `;

    [...container.querySelectorAll('a')].forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        setCurrentSortActive();
        if ($(window).width() > '768') {
          scroll(0, 0);
        } else {
          $('html, body').animate(
            { scrollTop: $($('.sort-container')[0]).offset().top - 100 },
            0
          );
        }

        refine(event.currentTarget.dataset.value);
      });
    });
  };

  const customPagination =
    instantsearch.connectors.connectPagination(renderPagination);

  search.addWidgets([customPagination({})]);

  const ONE_DAY_IN_MS = 3600 * 24 * 1000;

  // Date Range Picker
  const makeRangeWidget = instantsearch.connectors.connectRange(
    (options, isFirstRendering) => {
      if (!isFirstRendering) return;

      const { refine } = options;

      $('input[name="daterange"]').daterangepicker(
        {
          minYear: 1970,
          endDate: moment(),
          startDate: 'January 01, 1970',
          maxDate: moment(),
          alwaysShowCalendars: false,
          showDropdowns: true,
          locale: {
            format: 'MMMM DD, YYYY',
          },
          ranges: {
            'Last 30 days': [moment().subtract(29, 'days'), moment()],
            'Last 3 months': [
              moment().subtract(3, 'month').startOf('month'),
              moment(),
            ],
            'Last 6 months': [
              moment().subtract(6, 'month').startOf('month'),
              moment(),
            ],
            'Last year': [
              moment().subtract(12, 'month').startOf('month'),
              moment(),
            ],
            'All time': ['January 01, 1970', moment()],
          },
          opens: 'left',
        },
        (start, end, label) => {
          const startInMs = new Date(start).getTime();
          const endInMs = new Date(end).getTime();
          const actualEnd =
            startInMs == endInMs ? endInMs + ONE_DAY_IN_MS - 1 : endInMs;

          refine();
          refine([startInMs / 1000, actualEnd / 1000]);
        }
      );
    }
  );

  const dateRangeWidget = makeRangeWidget({
    attribute: 'date_timestamp',
  });

  search.addWidget(dateRangeWidget);

  search.start();

  function setCurrentSortActive() {
    const currentSort = $('#sort-by .ais-SortBy-select').val();
    $(
      `.searching-sort .search-sort-link[data-sort-key="${currentSort}"]`
    ).addClass('active');
  }

  $('.search-show-filters').click(function (e) {
    e.preventDefault();
    $('.searching-filters').toggleClass('open');
    $(this).text() == 'Show Filters'
      ? $(this).text('Hide Filters')
      : $(this).text('Show Filters');
  });

  $('.searching-filters__daterange-icon').click(function (e) {
    e.stopPropagation();
    if (!$(this).hasClass('active')) $('input[name="daterange"]').click();
    $(this).toggleClass('active');
  });

  $(document).click(() => {
    const daterangeIcon = $('.searching-filters__daterange-icon');
    if (daterangeIcon.hasClass('active')) daterangeIcon.removeClass('active');
  });

  $('.searching-filters__item-title').click(function (e) {
    $(this).parent().toggleClass('open');
  });

  $('.search-sort-link').on('click', (e) => {
    e.preventDefault();
    $('.search-sort-link').removeClass('active');
    $(e.currentTarget).addClass('active');
    $('#sort-by .ais-SortBy-select').val($(e.currentTarget).data('sort-key'));
    document
      .getElementsByClassName('ais-SortBy-select')[0]
      .dispatchEvent(new Event('change'));
  });

  setTimeout(setCurrentSortActive, 1000);
});
